import { render, staticRenderFns } from "./dispense-report-preview.vue?vue&type=template&id=2fcfcfec&scoped=true&"
import script from "./dispense-report-preview.vue?vue&type=script&lang=js&"
export * from "./dispense-report-preview.vue?vue&type=script&lang=js&"
import style0 from "./dispense-report-preview.vue?vue&type=style&index=0&id=2fcfcfec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfcfec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
